export default "__VITE_ASSET__J7_$ncp___"